module.exports = __webpack_public_path__ + "static/media/Image01.98029455.png";